// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/poppins/Poppins-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/poppins/Poppins-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/poppins/Poppins-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/poppins/Poppins-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/poppins/Poppins-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/poppins/Poppins-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/poppins/Poppins-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/poppins/Poppins-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/poppins/Poppins-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/poppins/Poppins-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/poppins/Poppins-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/poppins/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/poppins/Poppins-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/poppins/Poppins-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'); 
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 200;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 600;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 800;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('truetype');
}
@font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('truetype');
}  `, "",{"version":3,"sources":["webpack://./src/v3/assets/css/PoppinsFonts.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAoE;AACxE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA0E;AAC9E;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAqE;AACzE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAgE;AACpE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAsE;AAC1E;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAwE;AAC5E;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAoE;AACxE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAyE;AAC7E;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAqE;AACzE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA8D;AAClE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAAoE;AACxE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAA+D;AACnE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAAiE;AACrE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAAgE;AACpE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAAkE;AACtE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAA8D;AAClE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAAmE;AACvE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gEAA+D;AACnE","sourcesContent":["@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 100;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-ThinItalic.ttf) format('truetype'); \n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 200;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-ExtraLightItalic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 300;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-LightItalic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 400;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-Italic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 500;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-MediumItalic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 600;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-SemiBoldItalic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 700;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-BoldItalic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 800;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-ExtraBoldItalic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 900;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-BlackItalic.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 100;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-Thin.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 200;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-ExtraLight.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-Light.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-Regular.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 500;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-Medium.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 600;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-SemiBold.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-Bold.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 800;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-ExtraBold.ttf) format('truetype');\n}\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 900;\n    font-display: swap;\n    src: url(../fonts/poppins/Poppins-Black.ttf) format('truetype');\n}  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
